"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jquery_1 = __importDefault(require("jquery"));
jquery_1["default"].widget('IKS.hallohr', {
    options: {
        editable: null,
        toolbar: null,
        uuid: '',
        buttonCssClass: null
    },
    populateToolbar: function (toolbar) {
        var buttonset = jquery_1["default"]('<span class="' + this.widgetName + '"></span>');
        var buttonElement = jquery_1["default"]('<span></span>');
        buttonElement.hallobutton({
            uuid: this.options.uuid,
            editable: this.options.editable,
            label: 'Horizontal rule',
            command: 'insertHorizontalRule',
            icon: 'icon-horizontalrule',
            cssClass: this.options.buttonCssClass
        });
        buttonset.append(buttonElement);
        buttonset.hallobuttonset();
        return toolbar.append(buttonset);
    }
});
